import React, { useState } from "react";
import { Eye, EyeOff, CheckCircle2 } from "lucide-react";
import "./ChangePassword.scss";
import { PATCH_RESET_PASSWORD, POST_CHANGE_PASSWORD} from "../utils/api";
import axios from "axios";
import Loader from "../utils/loader/loader";
import ToastMessage from "../utils/toasts/toastMessage";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiRequest } from "../api/apiRequest";

const ChangePassword = () => {
  const nav = useNavigate();
  const [searchParams] = useSearchParams();
  const urlToken = searchParams.get("token");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });
  const [loading, setLoading] = useState(false);

  const validations = [
    { id: 1, text: "Minimum characters 6", valid: newPassword.length >= 6 },
    {
      id: 2,
      text: "One uppercase character",
      valid: /[A-Z]/.test(newPassword),
    },
    {
      id: 3,
      text: "One lowercase character",
      valid: /[a-z]/.test(newPassword),
    },
    {
      id: 4,
      text: "One special character",
      valid: /[!@#$%^&*(),.?":{}|<>]/.test(newPassword),
    },
    { id: 5, text: "One number", valid: /\d/.test(newPassword) },
  ];

  const isPasswordValid = validations.every((v) => v.valid);
  const passwordsMatch = newPassword && confirmPassword && newPassword === confirmPassword;
  const showPasswordError = (newPassword || confirmPassword) && !passwordsMatch;

  // const handleChangePassword = async () => {
  //   if (!oldPassword || !newPassword || !confirmPassword) {
  //     setToastState({
  //       show: true,
  //       message: "All fields are required!",
  //       type: "error",
  //     });
  //     return;
  //   }

  //   if (!isPasswordValid) {
  //     setToastState({
  //       show: true,
  //       message: "Password does not meet security requirements!",
  //       type: "error",
  //     });
  //     return;
  //   }

  //   if (newPassword !== confirmPassword) {
  //     setToastState({
  //       show: true,
  //       message: "New password and confirm password do not match!",
  //       type: "error",
  //     });
  //     return;
  //   }

  //   if (oldPassword === newPassword) {
  //     setToastState({
  //       show: true,
  //       message: "New password cannot be the same as old password! This password has already been used.",
  //       type: "error",
  //     });
  //     return;
  //   }

  //   setLoading(true);

  //   const token = localStorage.getItem("access_token") || null;
  //   const headers = {
  //     Authorization: `Bearer ${token}`,
  //   };

  //   try {
  //     const payload = {
  //       current_password: oldPassword,
  //       new_password: newPassword,
  //     };

  //     const resp = await axios.post(POST_CHANGE_PASSWORD, payload, {
  //       headers,
  //       withCredentials: true,
  //     });

  //     if (resp.status === 200) {
  //       const roleId = localStorage.getItem("role");

  //       if (+roleId === 1) {
  //         nav("/userprofile", { replace: true });
  //       } else if (+roleId === 2) {
  //         nav("/teacher-profile", { replace: true });
  //       } else if (+roleId === 3) {
  //         nav("/people", { replace: true });
  //       }
  //     }
  //   } 
  //   catch (err) {
  //     const errorContext = err?.resp?.response?.data?.detail;
  //     setToastState({
  //       show: true,
  //       message: errorContext|| "Password change failed!",
  //       type: "error",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleChangePassword = async () => {
  if (!oldPassword || !newPassword || !confirmPassword) {
    setToastState({
      show: true,
      message: "All fields are required!",
      type: "error",
    });
    return;
  }

  if (!isPasswordValid) {
    setToastState({
      show: true,
      message: "Password does not meet security requirements!",
      type: "error",
    });
    return;
  }

  if (newPassword !== confirmPassword) {
    setToastState({
      show: true,
      message: "New password and confirm password do not match!",
      type: "error",
    });
    return;
  }

  if (oldPassword === newPassword) {
    setToastState({
      show: true,
      message:
        "New password cannot be the same as old password! This password has already been used.",
      type: "error",
    });
    return;
  }

  setLoading(true);

  const payload = {
    current_password: oldPassword,
    new_password: newPassword,
  };

  // skipAuthRedirect: true — a 401 here almost certainly means "wrong old
  // password", not "session expired" (the user is still logged in). Without
  // this, the global interceptor would clear the token and redirect to "/"
  // before the toast below can even render.
  const result = await apiRequest("post", POST_CHANGE_PASSWORD, payload, {
    skipAuthRedirect: true,
  });

  setLoading(false);

  if (!result.success) {
    setToastState({
      show: true,
      message: result.message || "Password change failed!",
      type: "error",
    });
    return;
  }

  const roleId = localStorage.getItem("role");

  if (+roleId === 1) {
    nav("/userprofile", { replace: true });
  } else if (+roleId === 2) {
    nav("/teacher-profile", { replace: true });
  } else if (+roleId === 3) {
    nav("/people", { replace: true });
  }
};

  // const handleResetPassword = async () => {
  //   if (!newPassword || !confirmPassword) {
  //     setToastState({
  //       show: true,
  //       message: "All fields are required!",
  //       type: "error",
  //     });
  //     return;
  //   }

  //   if (!isPasswordValid) {
  //     setToastState({
  //       show: true,
  //       message: "Password does not meet security requirements!",
  //       type: "error",
  //     });
  //     return;
  //   }

  //   if (newPassword !== confirmPassword) {
  //     setToastState({
  //       show: true,
  //       message: "New password and confirm password do not match!",
  //       type: "error",
  //     });
  //     return;
  //   }

  //   setLoading(true);

  //   const token = urlToken || null;

  //   const headers = {
  //     Authorization: `Bearer ${token}`,
  //   };

  //   try {
  //     const payload = {
  //       new_password: newPassword,
  //       token: token,
  //     };

  //     const resp = await axios.patch(PATCH_RESET_PASSWORD, payload, {
  //       headers,
  //       withCredentials: true,
  //     });
  //     if (resp?.status === 200) {
  //       setLoading(true);
  //       setToastState({
  //         show: true,
  //         message: "account created successfully",
  //         type: "success",
  //       });
  //       setTimeout(() => {
  //         nav("/");
  //       }, 500);
  //     } else {
  //       setToastState({
  //         show: true,
  //         message: "unable to rest password",
  //         type: "error",
  //       });
  //     }
  //   } catch (err) {
  //     setToastState({
  //       show: true,
  //       message: err?.response?.data?.message || "Password reset failed!",
  //       type: "error",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleResetPassword = async () => {
  if (!newPassword || !confirmPassword) {
    setToastState({
      show: true,
      message: "All fields are required!",
      type: "error",
    });
    return;
  }

  if (!isPasswordValid) {
    setToastState({
      show: true,
      message: "Password does not meet security requirements!",
      type: "error",
    });
    return;
  }

  if (newPassword !== confirmPassword) {
    setToastState({
      show: true,
      message: "New password and confirm password do not match!",
      type: "error",
    });
    return;
  }

  setLoading(true);

  const token = urlToken || null;

  const payload = {
    new_password: newPassword,
    token: token,
  };

  // This flow authenticates with the one-time urlToken from the reset
  // link, NOT the logged-in user's stored access_token — so we set
  // Authorization explicitly here. apiClient's interceptor is set up to
  // respect an already-present Authorization header rather than overwrite
  // it with the stored access_token.
  // skipAuthRedirect: true — a 401 here means an invalid/expired reset
  // link, not "session expired", so we handle the error inline instead of
  // letting the global interceptor redirect away.
  const result = await apiRequest("patch", PATCH_RESET_PASSWORD, payload, {
    headers: { Authorization: `Bearer ${token}` },
    skipAuthRedirect: true,
  });

  setLoading(false);

  if (!result.success) {
    setToastState({
      show: true,
      message: result.message || "Password reset failed!",
      type: "error",
    });
    return;
  }

  setToastState({
    show: true,
    message: "account created successfully",
    type: "success",
  });
  setTimeout(() => {
    nav("/");
  }, 500);
};

  return (
    <div className="change-password-container">
      {urlToken ? (
        <div className="password-card">
          <h2>Reset Password</h2>

          <div>
            {/* NEW PASSWORD */}
            <div className="form-group">
              <label>New Password</label>
              <div className="input-wrapper">
                <input
                  type={showNew ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className={
                    !isPasswordValid && newPassword.length > 0 ? "error" : ""
                  }
                />
                <button
                  type="button"
                  className="toggle-btn"
                  onClick={() => setShowNew(!showNew)}
                >
                  {showNew ? <Eye size={20} /> : <EyeOff size={20} />}
                </button>
              </div>

              {/* Validation List */}
              {!isPasswordValid && newPassword.length > 0 && (
                <div className="validation-section">
                  <p className="error-msg">
                    Please add all necessary characters to create safe password.
                  </p>
                  <ul className="validation-list">
                    {validations.map((item) => (
                      <li key={item.id}>
                        <div
                          className={`dot ${!item.valid ? "invalid" : ""}`}
                        ></div>
                        <span className={!item.valid ? "invalid" : ""}>
                          {item.text}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* CONFIRM PASSWORD */}
            <div className="form-group">
              <label>Confirm New Password</label>
              <div className="input-wrapper">
                <input
                  type={showConfirm ? "text" : "password"}
                  placeholder="enter your confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className={passwordsMatch ? 'password-match' : showPasswordError ? 'password-error' : ''}
                />
                <button
                  type="button"
                  className="toggle-btn"
                  onClick={() => setShowConfirm(!showConfirm)}
                >
                  {showConfirm ? <Eye size={20} /> : <EyeOff size={20} />}
                </button>
              </div>
            </div>

            {/* BUTTON */}
            <button className={`submit-btn ${passwordsMatch ? 'btn-success' : ''}`} onClick={handleResetPassword}>
              Reset Password
            </button>
          </div>
        </div>
      ) : (
        <div className="password-card">
          <h2>Change Password</h2>

          <div>
            {/* OLD PASSWORD */}
            <div className="form-group">
              <div className="label-with-icon">
                <label>Current Password</label>
                {oldPassword.length > 0 && (
                  <CheckCircle2 className="success-icon" />
                )}
              </div>
              <div className="input-wrapper">
                <input
                  placeholder="Enter current password"
                  type={showOld ? "text" : "password"}
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  className={oldPassword.length > 0 ? "success" : ""}
                />
                <button
                  type="button"
                  className="toggle-btn"
                  onClick={() => setShowOld(!showOld)}
                >
                  {showOld ? <Eye size={20} /> : <EyeOff size={20} />}
                  
                </button>
              </div>
            </div>

            {/* NEW PASSWORD */}
            <div className="form-group">
              <label>New Password</label>
              <div className="input-wrapper">
                <input
                 placeholder="Enter new password"
                  type={showNew ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className={
                    !isPasswordValid && newPassword.length > 0 ? "error" : ""
                  }
                />
                <button
                  type="button"
                  className="toggle-btn"
                  onClick={() => setShowNew(!showNew)}
                >
                  {showNew ? <Eye size={20} /> : <EyeOff size={20} />}
                </button>
              </div>

              {/* Validation List */}
              {!isPasswordValid && newPassword.length > 0 && (
                <div className="validation-section">
                  <p className="error-msg">
                    Please add all necessary characters to create safe password.
                  </p>
                  <ul className="validation-list">
                    {validations.map((item) => (
                      <li key={item.id}>
                        <div
                          className={`dot ${!item.valid ? "invalid" : ""}`}
                        ></div>
                        <span className={!item.valid ? "invalid" : ""}>
                          {item.text}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* CONFIRM PASSWORD */}
            <div className="form-group">
              <label>Confirm New Password</label>
              <div className="input-wrapper">
                <input
                  type={showConfirm ? "text" : "password"}
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className={passwordsMatch ? 'password-match' : showPasswordError ? 'password-error' : ''}
                />
                <button
                  type="button"
                  className="toggle-btn"
                  onClick={() => setShowConfirm(!showConfirm)}
                >
                  {showConfirm ? <Eye size={20} /> : <EyeOff size={20} />}
                </button>
              </div>
            </div>

            {/* BUTTON */}
            <button className={`submit-btn ${passwordsMatch ? 'btn-success' : ''}`} onClick={handleChangePassword}>
              Change Password
            </button>
          </div>
        </div>
      )}

      <Loader show={loading} />
      <ToastMessage
        show={toastState.show}
        onClose={() => setToastState({ show: false, message: "", type: "" })}
        message={toastState.message}
        type={toastState.type}
      />
    </div>
  );
};

export default ChangePassword;
